import(/* webpackMode: "eager", webpackExports: ["MantineProvider"] */ "/vercel/path0/node_modules/@mantine/core/esm/core/MantineProvider/MantineProvider.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(admin)/[lang]/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["AdminShell"] */ "/vercel/path0/src/components/AdminShell/AdminShell.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientWrapper"] */ "/vercel/path0/src/components/ClientWrapper/ClientWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/CookieBanner/CookieBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/dictionaries/dictionary-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["theme"] */ "/vercel/path0/theme.ts");
